import React from 'react'
import Route from 'route-parser'
import IconButton from '@material-ui/core/IconButton'
import PrintIcon from '@material-ui/icons/Print'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import Grid from '@material-ui/core/Grid'
import { getBaseURI } from 'front-end-core/helpers/document'
import { dismissPopover } from 'services/OverlayService'
import ArrowLink from 'components/redesign/ArrowLink'

const ReviewHeader = ({ short, pdfUrl: url, returnUrl, returnText, isLogged, setSignUpModalIsOpen, aol }) => {
  const pdfUrl = getBaseURI() + new Route(url).reverse({ aol, short })

  const handleOnClick = (e) => {
    dismissPopover(e.target)
    if (!isLogged) {
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    }
  }

  return (
    <div>
      <div className='bg-void-grey pv2'>
        <div className='layout-width-constraint'>
          <div className='flex justify-end pr6'>
            <div className='ph2 f5'>
              <IconButton size='small' onClick={handleOnClick}>
                <a href={pdfUrl} target='_blank' rel='noopener noreferrer'>
                  <PrintIcon classes={{ root: 'black vm' }} />
                </a>
              </IconButton>
            </div>
            <div className='ph2 f5'>
              <IconButton size='small' onClick={handleOnClick}>
                <a
                  href={pdfUrl}
                  download='FromCounsel - Selected content.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <PictureAsPdfIcon classes={{ root: 'black vm' }} />
                </a>
              </IconButton>
            </div>
          </div>
        </div>
      </div>
      <div className='layout-width-constraint pt9'>
        <Grid container>
          <Grid item>
            <div>
              <ArrowLink
                backArrow
                text={returnText}
                textCx='mb4'
                url={returnUrl}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default ReviewHeader
